import React from "react"
import { connect } from "react-redux"
import { Avatar, Tooltip } from "antd"
import infinity from "../../assets/images/infinity.svg"
import _ from "../../utils/lodashUtils"
import "./ChatHeader.scss"
import bubbleArtProfile from "../../assets/images/bubble_art_1.svg"
import bubbleArtPartner from "../../assets/images/bubble_art.svg"
import oval from "../../assets/images/oval.svg"
import { ChatPopup } from "../ChatPopup/ChatPopup"
import SpaceModal from "../../components/SpaceModal/SpaceModal"
import AddressModal from "../AddressModal/AddressModal"
import { TextTag } from "../../atoms"
import { FirebaseContext, FIREBASE_STATE_KEYS } from "../../firebase"
import emptyProfileIcon from "../../assets/images/profile.svg"
import {
  GET_ROBO_IMAGE,
  DEFAULT_SPACE_NAME,
  EDIT_ADDRESS,
} from "../../constants/messages"
import { useIsMobile } from "common-custom-hooks"
import LocationIcon from "../../assets/images/Location.svg"
import { getPartnerNameorNickName } from "../../utils/helpers"
import { SCREENS } from "../../constants/screens"
import history from "../../history"
import { fetchPartnerDetails } from "../../redux/actionCreators/invitePeople"

const ChatHeader = props => {
  const { dateState, userState, partnerState } = React.useContext(
    FirebaseContext
  )
  let me = _.get(userState, "userDetails", {})
  let partner = _.get(partnerState, "userDetails", {})
  const chatSpaceName = _.get(
    dateState,
    "chatSpaceName",
    _.get(props.invitePeople, "chat_space_name", "")
  )
  let partnerAdress = _.get(partner, "address.user_address", "")
  const activeScreen = _.get(userState, "activeScreen")
  const userAddress = _.get(userState, "userDetails.address.user_address")
  const showAddressSpace =
    userAddress && partnerAdress && activeScreen != SCREENS.ADDRESS_WAIT_SCREEN
  const isMobile = useIsMobile(768)

  React.useEffect(() => {
    // on change of date status, fetch the partner details if not available
    if (
      _.get(dateState, FIREBASE_STATE_KEYS.STATUS) === "ACTIVE" &&
      activeScreen !== "COUPLING" &&
      activeScreen !== "CONTACT" &&
      activeScreen !== "MY_PARTNER" &&
      (_.isEmpty(props.myPartner) || !props.myPartner?.display_name)
    ) {
      props.fetchPartnerDetails()
    }
  }, [dateState])

  const partnerName = getPartnerNameorNickName(
    _.get(dateState, FIREBASE_STATE_KEYS.STATUS) === "ACTIVE"
      ? partnerState
      : "",
    props.myPartner,
    props.invitePeople
  )
  const userDisplayName = getPartnerNameorNickName(
    _.get(userState, "userDetails", {}),
    props.user
  )
  const onlinePartner = _.get(partnerState, "presence.isOnline")
  const goToChangepartner = () => {
    history.push("/my-partner")
  }
  const goToMyProfile = () => {
    localStorage.removeItem("isPathFromLogin")
    history.push("/contact")
  }
  //address for both user and partner below their profile
  const renderAddressSpace = () => {
    return (
      showAddressSpace && (
        <div className="address-space">
          <div className="address-user">
            <AddressModal
              buttonType={"link"}
              buttonText={EDIT_ADDRESS}
              onSubmit={() => {}}
              dateState={dateState}
              userState={userState}
              partnerState={partnerState}
              address={_.get(me, "address.user_address", "")}
            />
          </div>
          {partnerState && partnerState.activeScreen !== "GET_ADDRESS" && (
            <div className="address-partner">
              {partnerAdress && (
                <div>
                  <img
                    className="location-icon"
                    src={LocationIcon}
                    alt="location"
                  />
                </div>
              )}
              <Tooltip title={partnerAdress}>
                <TextTag textType="smallTextSecondary" className="address-bar">
                  {partnerAdress}
                </TextTag>
              </Tooltip>
            </div>
          )}
        </div>
      )
    )
  }

  return (
    <div id="chatHeader">
      <div className="space-name">
        <TextTag textType="spaceName" className="space-name-txt">
          {chatSpaceName ? chatSpaceName : DEFAULT_SPACE_NAME}{" "}
        </TextTag>
        <div className="space-name-edit-btn">
          <SpaceModal
            buttonType={"link"}
            onSubmit={() => {}}
            chatSpaceName={chatSpaceName}
          />
        </div>
      </div>
      <div id="couplingContainer">
        <div className="profile-container">
          <div className="my-profile">
            <img
              className="bubble-profile"
              src={bubbleArtProfile}
              alt="bubbles"
            />
            <img className="ovalBg" src={oval} alt="Oval" />
            <div id="avatar1" className="click-hand">
              {!_.isEmpty(me) && !_.isEmpty(me.profile_image) ? (
                <Avatar src={me.profile_image} onClick={goToMyProfile} />
              ) : (
                <Avatar
                  src={GET_ROBO_IMAGE(userDisplayName)}
                  onClick={goToMyProfile}
                />
              )}
            </div>
          </div>
        </div>

        <div className="space-image">
          <div className="bar">
            <div className="coupling-connector" />
            <img src={infinity} alt="infinity" className="connection" />
          </div>
          {!isMobile && renderAddressSpace()}
        </div>
        <div className="profile-container">
          <div className="partner-profile">
            <img
              className="bubble-partner"
              src={bubbleArtPartner}
              alt="bubbles"
            />
            <img className="ovalBg" src={oval} alt="Oval" />
            {!_.isEmpty(_.get(partner, "profile_image")) ? (
              <div className="chatContainer click-hand">
                <Avatar
                  className={`${onlinePartner ? "circle" : ""}`}
                  src={partner.profile_image}
                  onClick={goToChangepartner}
                />
                {activeScreen !== "COUPLING" &&
                  activeScreen !== "CONTACT" &&
                  activeScreen !== "MY_PARTNER" && (
                    <ChatPopup partner={partner}></ChatPopup>
                  )}
              </div>
            ) : (
              <div className="chatContainer click-hand">
                {partnerName ? (
                  <Avatar
                    className={`${onlinePartner ? "circle" : ""}`}
                    src={GET_ROBO_IMAGE(partnerName)}
                    onClick={goToChangepartner}
                  />
                ) : (
                  <Avatar
                    className={`${onlinePartner ? "circle" : ""}`}
                    src={emptyProfileIcon}
                    onClick={goToChangepartner}
                  />
                )}
                {activeScreen !== "COUPLING" &&
                  activeScreen !== "CONTACT" &&
                  activeScreen !== "MY_PARTNER" && (
                    <ChatPopup partner={partner}></ChatPopup>
                  )}
              </div>
            )}
          </div>
        </div>
      </div>
      {isMobile && renderAddressSpace()}
    </div>
  )
}

const mapStateToProps = state => {
  return {
    myPartner: _.get(state, "auth.partner"),
    invitePeople: _.get(state, "invitePeople.partnerDetails"),
    user: _.get(state, "auth.user"),
  }
}

export default connect(mapStateToProps, { fetchPartnerDetails })(ChatHeader)
